import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { isValidUUID } from 'app/utils';

export default function MasterServiceCategoryGuard({ children }) {
  const { categoryId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isValidUUID(categoryId)) {
      const redirectUrl = `/master-services/categories`;
      navigate(redirectUrl);
    }
  }, [categoryId, navigate]);

  if (!isValidUUID(categoryId)) {
    return null;
  }

  return children;
}
